import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { BigContainer } from "../general/GeneralStyles"
import ProductCategorySearch from "./ProductCategorySearch"
import ProductSearchBar from "./ProductSearchBar"
import { produce } from "immer"
import ProductsContainer from "./ProductsContainer"
import axios from "axios"
import SearchBar, { SearchBarContainer } from "../general/SearchBar"

// const instance = axios.create({ baseURL: "http://localhost:8001" })

const Wrapper = styled(BigContainer)`
  display: grid;
  grid-template-columns: 2fr 9fr 1fr;
  z-index: 10;
  padding-bottom: 50px;

  ${SearchBarContainer} {
    span {
      padding: 13px 20px;
    }

    input {
      padding: 10px 30px;
    }

    @media (max-width: ${props => props.theme.mediumBreakpoint}) {
      width: 100%;
    }
  }

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    grid-template-columns: 1fr;
  }
`

const RightContainer = styled.div`
  border-left: solid 2px #f0efea;
  padding-left: 20px;

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    padding-left: 0px;
    border-left: 0;
  }
`

const ProductsWrapper = props => {
  const [products, setProducts] = useState([
    {
      id: 1,
      name: "Prang Oval Pan Watercolor Set",
      description:
        "<p>Ever the gold standard in watercolors, Prang<sup>®</sup> Watercolors offer smoothness, perfect blending, intense pigments and the best tone palette of its kind. Each Prang Semi-Moist Oval Pan Watercolor Set features extra-deep pans that can easily be replaced by refills, a wood-handled paintbrush and a strong white plastic case with built-in mixing area.</p>\n<p>Available in 8ct and 16 sets in a clamshell packaging. AP certified non-toxic. Conforms to ASTM standards.</p>\n",
      points: 30,
      img_url:
        "http://prang.local/wp-content/uploads/2019/04/EDB29DF2-1E4F-395D-A3CD6145C81A2094.jpg",
      category: "Watercolors",
      created_at: "2019-04-18 15:39:31",
      updated_at: "2019-04-18 15:39:31",
    },
    {
      id: 2,
      name: "Prang Oval Pan Master Pack",
      description: "<p>Features 24 sets of 00800 and 36 refill trays</p>\n",
      points: 30,
      img_url:
        "http://prang.local/wp-content/uploads/2019/04/0AB71335-1E4F-395D-A3DBAD4F09FCD758.jpg",
      category: "Packs",
      created_at: "2019-04-18 15:39:31",
      updated_at: "2019-04-18 15:39:31",
    },
    {
      id: 3,
      name: "Prang - Half Pan Watercolor Sets",
      description:
        "<p>Prang<sup>®</sup> Half Pan Watercolor Sets offer premium, intense pigments for brilliant color, a unique semi-moist, wax-free formulation and the best tone palette of its kind. Refills easily snap into the sturdy white case which includes a built-in mixing area. Both sets include a wood-handled paintbrush. AP certified non-toxic. Conforms to ASTM standards.</p>\n",
      points: 30,
      img_url:
        "http://prang.local/wp-content/uploads/2019/04/14FBB927-1E4F-395D-A3175F460C1B06C0.jpg",
      category: "Watercolors",
      created_at: "2019-04-18 15:39:32",
      updated_at: "2019-04-18 15:39:32",
    },
    {
      id: 4,
      name: "Prang Refill Pans for Oval Watercolor Sets",
      description:
        ' <p>Prang<sup>®</sup> Semi-Moist Oval Pan Watercolor Refills are available in 17 brilliant colors of the watercolors renowned as "the first and still the finest" in the industry. These colors are also available individually as are nine additional colors. Individual colors are available in 12ct. AP certified non-toxic. Conforms to ASTM standards.</p>\n<div id="msds"></div>\n',
      points: 30,
      img_url:
        "http://prang.local/wp-content/uploads/2019/04/14F9FBB3-1E4F-395D-A3C2D50092B1DC62.jpg",
      category: "Refills",
      created_at: "2019-04-18 15:39:32",
      updated_at: "2019-04-18 15:39:32",
    },
    {
      id: 5,
      name: "Prang - Refill Tray for Oval Watercolor Sets",
      description:
        '<p>Quick. Easy. Economical. Eight vibrant colors ready to use in a snap! Same quality semi-moist paint as in the original. Watercolor refill tray simply snaps into your existing Oval-8 watercolor set. AP certified non-toxic.</p>\n<div id="msds"></div>\n',
      points: 20,
      img_url:
        "http://prang.local/wp-content/uploads/2019/04/EDE84579-1E4F-395D-A3C609FF131E1AF8.jpg",
      category: "Watercolors",
      created_at: "2019-04-18 15:39:32",
      updated_at: "2019-04-18 15:39:32",
    },
    {
      id: 6,
      name: "Prang - Washable Watercolor Set",
      description:
        '<p>Prang<sup>®</sup> Semi-Moist Washable Watercolors feature the tuned palette of brilliant colors and intense pigments that have made Prang the watercolors most preferred by teachers nationwide. These washable watercolors easily wash off clothes and skin with soap and water. AP certified non-toxic. Conforms to ASTM standards.</p>\n<div id="msds"></div>\n',
      points: 20,
      img_url:
        "http://prang.local/wp-content/uploads/2019/04/832864DB-1E4F-395D-A3538E0AF656990F.jpg",
      category: "Watercolors",
      created_at: "2019-04-18 15:39:32",
      updated_at: "2019-04-18 15:39:32",
    },
    {
      id: 7,
      name: "Prang Washable Watercolor Master Pack",
      description:
        '<p>Contains 36 sets of washable watercolors including 12 sets each of 8 classic colors, 8 metallic colors and 8 glitter colors. Each 8 color set contains a brush.</p>\n<div id="msds"></div>\n',
      points: 20,
      img_url:
        "http://prang.local/wp-content/uploads/2019/04/821D14A3-1E4F-395D-A39FCB5389471309.jpg",
      category: "Packs",
      created_at: "2019-04-18 15:39:32",
      updated_at: "2019-04-18 15:39:32",
    },
    {
      id: 8,
      name: "Prang - Whole Pan Watercolor Sets",
      description:
        "<p>Prang<sup>®</sup> Semi-Moist Whole Pan Watercolor Sets are a longer-lasting alternative to Prang's popular Oval-8 sets with twice as much paint. Prang's renowned intense pigments and the best tone palette of its kind. Refills are available in 12 colors. All sets are contained in strong white plastic cases with built-in mixing areas and each includes a wood-handled paintbrush. AP certified non-toxic. Conforms to ASTM standards.</p>\n<div id=\"msds\"></div>\n",
      points: 30,
      img_url:
        "http://prang.local/wp-content/uploads/2019/04/14FD84F3-1E4F-395D-A3CC464280E36C07.jpg",
      category: "Watercolors",
      created_at: "2019-04-18 15:39:32",
      updated_at: "2019-04-18 15:39:32",
    },
    {
      id: 9,
      name: "Prang - Whole Pan Watercolor Sets",
      description:
        "<p>Prang<sup>®</sup> Semi-Moist Whole Pan Watercolor Sets are a longer-lasting alternative to Prang's popular Oval-8 sets with twice as much paint. Prang's renowned intense pigments and the best tone palette of its kind. Refills are available in 12 colors. All sets are contained in strong white plastic cases with built-in mixing areas and each includes a wood-handled paintbrush. AP certified non-toxic. Conforms to ASTM standards.</p>\n<div id=\"msds\"></div>\n",
      points: 30,
      img_url:
        "http://prang.local/wp-content/uploads/2019/04/14FD84F3-1E4F-395D-A3CC464280E36C07.jpg",
      category: "Watercolors",
      created_at: "2019-04-18 15:39:32",
      updated_at: "2019-04-18 15:39:32",
    },
    {
      id: 10,
      name: "Prang - Whole Pan Watercolor Sets",
      description:
        "<p>Prang<sup>®</sup> Semi-Moist Whole Pan Watercolor Sets are a longer-lasting alternative to Prang's popular Oval-8 sets with twice as much paint. Prang's renowned intense pigments and the best tone palette of its kind. Refills are available in 12 colors. All sets are contained in strong white plastic cases with built-in mixing areas and each includes a wood-handled paintbrush. AP certified non-toxic. Conforms to ASTM standards.</p>\n<div id=\"msds\"></div>\n",
      points: 30,
      img_url:
        "http://prang.local/wp-content/uploads/2019/04/14FD84F3-1E4F-395D-A3CC464280E36C07.jpg",
      category: "Watercolors",
      created_at: "2019-04-18 15:39:32",
      updated_at: "2019-04-18 15:39:32",
    },
    {
      id: 11,
      name: "Prang - Whole Pan Watercolor Sets",
      description:
        "<p>Prang<sup>®</sup> Semi-Moist Whole Pan Watercolor Sets are a longer-lasting alternative to Prang's popular Oval-8 sets with twice as much paint. Prang's renowned intense pigments and the best tone palette of its kind. Refills are available in 12 colors. All sets are contained in strong white plastic cases with built-in mixing areas and each includes a wood-handled paintbrush. AP certified non-toxic. Conforms to ASTM standards.</p>\n<div id=\"msds\"></div>\n",
      points: 30,
      img_url:
        "http://prang.local/wp-content/uploads/2019/04/14FD84F3-1E4F-395D-A3CC464280E36C07.jpg",
      category: "Watercolors",
      created_at: "2019-04-18 15:39:32",
      updated_at: "2019-04-18 15:39:32",
    },
    {
      id: 12,
      name: "Prang - Whole Pan Watercolor Sets",
      description:
        "<p>Prang<sup>®</sup> Semi-Moist Whole Pan Watercolor Sets are a longer-lasting alternative to Prang's popular Oval-8 sets with twice as much paint. Prang's renowned intense pigments and the best tone palette of its kind. Refills are available in 12 colors. All sets are contained in strong white plastic cases with built-in mixing areas and each includes a wood-handled paintbrush. AP certified non-toxic. Conforms to ASTM standards.</p>\n<div id=\"msds\"></div>\n",
      points: 30,
      img_url:
        "http://prang.local/wp-content/uploads/2019/04/14FD84F3-1E4F-395D-A3CC464280E36C07.jpg",
      category: "Watercolors",
      created_at: "2019-04-18 15:39:32",
      updated_at: "2019-04-18 15:39:32",
    },
    {
      id: 13,
      name: "Prang - Whole Pan Watercolor Sets",
      description:
        "<p>Prang<sup>®</sup> Semi-Moist Whole Pan Watercolor Sets are a longer-lasting alternative to Prang's popular Oval-8 sets with twice as much paint. Prang's renowned intense pigments and the best tone palette of its kind. Refills are available in 12 colors. All sets are contained in strong white plastic cases with built-in mixing areas and each includes a wood-handled paintbrush. AP certified non-toxic. Conforms to ASTM standards.</p>\n<div id=\"msds\"></div>\n",
      points: 30,
      img_url:
        "http://prang.local/wp-content/uploads/2019/04/14FD84F3-1E4F-395D-A3CC464280E36C07.jpg",
      category: "Watercolors",
      created_at: "2019-04-18 15:39:32",
      updated_at: "2019-04-18 15:39:32",
    },
    {
      id: 14,
      name: "Prang - Whole Pan Watercolor Sets",
      description:
        "<p>Prang<sup>®</sup> Semi-Moist Whole Pan Watercolor Sets are a longer-lasting alternative to Prang's popular Oval-8 sets with twice as much paint. Prang's renowned intense pigments and the best tone palette of its kind. Refills are available in 12 colors. All sets are contained in strong white plastic cases with built-in mixing areas and each includes a wood-handled paintbrush. AP certified non-toxic. Conforms to ASTM standards.</p>\n<div id=\"msds\"></div>\n",
      points: 30,
      img_url:
        "http://prang.local/wp-content/uploads/2019/04/14FD84F3-1E4F-395D-A3CC464280E36C07.jpg",
      category: "Watercolors",
      created_at: "2019-04-18 15:39:32",
      updated_at: "2019-04-18 15:39:32",
    },
    {
      id: 15,
      name: "Prang - Whole Pan Watercolor Sets",
      description:
        "<p>Prang<sup>®</sup> Semi-Moist Whole Pan Watercolor Sets are a longer-lasting alternative to Prang's popular Oval-8 sets with twice as much paint. Prang's renowned intense pigments and the best tone palette of its kind. Refills are available in 12 colors. All sets are contained in strong white plastic cases with built-in mixing areas and each includes a wood-handled paintbrush. AP certified non-toxic. Conforms to ASTM standards.</p>\n<div id=\"msds\"></div>\n",
      points: 30,
      img_url:
        "http://prang.local/wp-content/uploads/2019/04/14FD84F3-1E4F-395D-A3CC464280E36C07.jpg",
      category: "Watercolors",
      created_at: "2019-04-18 15:39:32",
      updated_at: "2019-04-18 15:39:32",
    },
    {
      id: 16,
      name: "Prang - Whole Pan Watercolor Sets",
      description:
        "<p>Prang<sup>®</sup> Semi-Moist Whole Pan Watercolor Sets are a longer-lasting alternative to Prang's popular Oval-8 sets with twice as much paint. Prang's renowned intense pigments and the best tone palette of its kind. Refills are available in 12 colors. All sets are contained in strong white plastic cases with built-in mixing areas and each includes a wood-handled paintbrush. AP certified non-toxic. Conforms to ASTM standards.</p>\n<div id=\"msds\"></div>\n",
      points: 30,
      img_url:
        "http://prang.local/wp-content/uploads/2019/04/14FD84F3-1E4F-395D-A3CC464280E36C07.jpg",
      category: "Watercolors",
      created_at: "2019-04-18 15:39:32",
      updated_at: "2019-04-18 15:39:32",
    },
    {
      id: 17,
      name: "Prang - Whole Pan Watercolor Sets",
      description:
        "<p>Prang<sup>®</sup> Semi-Moist Whole Pan Watercolor Sets are a longer-lasting alternative to Prang's popular Oval-8 sets with twice as much paint. Prang's renowned intense pigments and the best tone palette of its kind. Refills are available in 12 colors. All sets are contained in strong white plastic cases with built-in mixing areas and each includes a wood-handled paintbrush. AP certified non-toxic. Conforms to ASTM standards.</p>\n<div id=\"msds\"></div>\n",
      points: 30,
      img_url:
        "http://prang.local/wp-content/uploads/2019/04/14FD84F3-1E4F-395D-A3CC464280E36C07.jpg",
      category: "Watercolors",
      created_at: "2019-04-18 15:39:32",
      updated_at: "2019-04-18 15:39:32",
    },
  ])
  const [categories, setCategories] = useState([])
  const [filteredProducts, setFilter] = useState([])
  const [activeFilter, setActiveFilter] = useState(false)

  const handleFilterChange = (e, index) => {
    const nextCategories = produce(categories, draftCategories => {
      draftCategories[index].active = e.target.checked
    })

    setCategories(nextCategories)
  }

  const filter = search => {
    setActiveFilter(false)
    let newFilteredProducts = products

    if (search) {
      newFilteredProducts = newFilteredProducts.filter(
        product => product.name.toLowerCase().indexOf(search) >= 0
      )
    }

    let newFilteredProducts2 = []
    let hasCheckboxFilter = false
    for (let i = 0; i < categories.length; i++) {
      if (categories[i].active) {
        setActiveFilter(true)
        hasCheckboxFilter = true
        let filteredProducts2 = newFilteredProducts.filter(
          product => product.category.indexOf(categories[i].category) >= 0
        )
        newFilteredProducts2 = newFilteredProducts2.concat(filteredProducts2)
      }
    }

    if (hasCheckboxFilter) {
      setFilter(newFilteredProducts2)
      setActiveFilter(true)
    } else {
      setFilter(newFilteredProducts)
      setActiveFilter(true)
    }
  }

  useEffect(() => {
    filter()
  }, [categories])

  useEffect(() => {
    /* TODO: comment this back in */
    // instance
    axios
      .get("/wp-products/")
      .then(response => {
        let products = response.data
        console.log(products)
        setProducts(products)
        let temporaryCategories = []
        for (let i = 0; i < products.length; i++) {
          products[i].category.forEach(productCategory => {
            if (
              temporaryCategories.filter(
                category => category.category == productCategory
              ).length == 0
            ) {
              temporaryCategories.push({
                category: productCategory,
                active: false,
              })
            }
          })
        }
        setCategories(temporaryCategories)
        console.log(categories)
      })
      .catch(error => {
        console.log(error)
      })
  }, [])

  const clearFilters = () => {
    const nextCategories = produce(categories, draftCategories => {
      draftCategories.forEach(category => {
        category.active = false
      })
    })
    setCategories(nextCategories)
    setFilter(products)
  }

  return (
    <Wrapper>
      {products ? (
        <>
          <ProductCategorySearch
            handleFilterChange={handleFilterChange}
            clearFilters={clearFilters}
            categories={categories}
          />
          <RightContainer>
            <SearchBar
              placeholder="Search for a product"
              onClick={filter}
              width="100%"
            />
            <ProductsContainer
              products={activeFilter ? filteredProducts : products}
            />
          </RightContainer>
        </>
      ) : null}
    </Wrapper>
  )
}

export default ProductsWrapper
